import { render, staticRenderFns } from "./HeroTwo.vue?vue&type=template&id=c6b44fa0&scoped=true&lang=pug&"
import script from "./HeroTwo.vue?vue&type=script&lang=js&"
export * from "./HeroTwo.vue?vue&type=script&lang=js&"
import style0 from "./HeroTwo.vue?vue&type=style&index=0&id=c6b44fa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b44fa0",
  null
  
)

export default component.exports